import { EcosActionType } from '../enums/ecos.enum';

export class DoActionPayload {
  answerType: EcosActionType;
  answerContent: string;
  lastOpenAiResponseId?: string;

  constructor(answerType: EcosActionType, answerContent: string, lastOpenAiResponseId?: string) {
    this.answerType = answerType;
    this.answerContent = answerContent;
    this.lastOpenAiResponseId = lastOpenAiResponseId;
  }
}
